var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-card",
    [
      _c("div", { staticClass: "disp-flex" }, [
        _c(
          "div",
          [
            _c(
              "el-button",
              {
                attrs: { type: "text" },
                on: {
                  click: function($event) {
                    return _vm.handleActionItemClick(_vm.item)
                  }
                }
              },
              [
                _vm.item.action
                  ? _c("i", {
                      staticClass: "el-icon-view",
                      attrs: { size: "large" }
                    })
                  : _vm._e(),
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$translate.action_message_code(_vm.item.message_code)
                    ) +
                    "\n\t\t\t\t"
                ),
                _vm.item.action_by_reference &&
                _vm.item.action_by_reference.primary_invoice_by_reference
                  ? _c("span", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            _vm.item.action_by_reference
                              .primary_invoice_by_reference.invoice_number
                          ) +
                          "\n\t\t\t\t"
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.item.action_by_reference
              ? _c(
                  "div",
                  _vm._l(_vm.item.action_by_reference.notes, function(note) {
                    return _c("div", { key: note.reference }, [
                      note.category
                        ? _c(
                            "div",
                            {
                              staticClass: "mb-5",
                              staticStyle: { color: "#303133" }
                            },
                            [
                              _c("b", [
                                _vm._v(" " + _vm._s(_vm.$t("result")) + ":  ")
                              ]),
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "callresultCategory." + note.category
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      note.category
                        ? _c(
                            "div",
                            {
                              staticClass: "mb-5",
                              staticStyle: { color: "#303133" }
                            },
                            [
                              _c("b", [
                                _vm._v(" " + _vm._s(_vm.$t("note")) + "  ")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "rgb(115, 115, 115) !important"
                          }
                        },
                        [
                          note.note && !_vm.expanded
                            ? [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm._f("excerpt")(note.note)) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            : note.note
                            ? [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(note.note) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          note.note && note.note.length > 300 && !_vm.expanded
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-5 hover-underline cursor-pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.handleShowAll()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("readMore")) + "...")]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.expanded
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-5 hover-underline cursor-pointer",
                                    on: {
                                      click: function($event) {
                                        return _vm.handleShowLess()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("readLess")) + "...")]
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  }),
                  0
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ml-auto" },
          [
            _vm.item.status && _vm.item.status === "CANCELED"
              ? _c("el-tag", { attrs: { size: "mini", type: "danger" } }, [
                  _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.status && _vm.item.status === "DONE"
              ? _c("el-tag", { attrs: { size: "mini", type: "success" } }, [
                  _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.status && _vm.item.status === "PROCESSING"
              ? _c("el-tag", { attrs: { size: "mini", type: "warning" } }, [
                  _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.item.status && _vm.item.status === "FAILED"
              ? _c("el-tag", { attrs: { size: "mini", type: "danger" } }, [
                  _vm._v(_vm._s(_vm.$translate.action_status(_vm.item.status)))
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.item.metadata?.channels[0]?.subject
        ? _c("div", { staticClass: "mb-5 ellipsis" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(_vm.item.metadata?.channels[0]?.subject) +
                "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fs-13" },
        [
          _vm.item.action_by_reference &&
          _vm.item.action_by_reference.canceler_by_reference
            ? _c("div", [
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.$tc("item.canceled_by")) + "\n\t\t\t"
                ),
                _c("b", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.item.action_by_reference.canceler_by_reference
                          .username
                      ) +
                      "\n\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    " " +
                      _vm._s(_vm.item.action_by_reference.cancel_reason) +
                      " "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.action_by_reference &&
          _vm.item.action_by_reference.executed_by_reference
            ? _c("div", [
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.$tc("item.executed_by")) + "\n\t\t\t"
                ),
                _c("b", [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.item.action_by_reference.executed_by_reference
                          .username
                      ) +
                      "\n\t\t\t"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.action_by_reference.action_invoices &&
          _vm.item.action_by_reference.action_invoices.length >= 1
            ? [
                _c(
                  "div",
                  { staticClass: "mt-10" },
                  [
                    _c("div", [
                      _c("span", [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("regardsTo")) +
                            "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$tc(
                                "invoiceWithTotal",
                                _vm.item.action_by_reference.action_invoices
                                  .length,
                                {
                                  value:
                                    _vm.item.action_by_reference.action_invoices
                                      .length
                                }
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(
                      _vm.item.action_by_reference.action_invoices,
                      function(action_invoice) {
                        return _c(
                          "el-tag",
                          {
                            key: action_invoice.invoice_by_reference.reference,
                            staticClass: "cursor-pointer mr-5 mb-5",
                            attrs: { size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.handleInvoiceClick(
                                  action_invoice.invoice_by_reference.reference
                                )
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "hover-underline" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    action_invoice.invoice_by_reference
                                      .invoice_number
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          ]
                        )
                      }
                    )
                  ],
                  2
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.item.action_by_reference.action_interchanges.length >= 1
            ? [
                _c("div", { staticClass: "mt-10" }, [
                  _c("span", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("deliveryDetails")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._l(
                  _vm.item.action_by_reference.action_interchanges,
                  function(ai) {
                    return _c(
                      "div",
                      { key: `${JSON.stringify(ai)}` },
                      [
                        ai.interchange_by_reference.channel == "MAIL" &&
                        ai.interchange_by_reference.barcode
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    href: `https://track.bpost.cloud/btr/web/#/search?lang=nl&itemCode=${
                                      ai.interchange_by_reference.barcode
                                    }&postalCode=${
                                      _vm.item.action_by_reference.zip_code1
                                        ? _vm.item.action_by_reference.zip_code1
                                        : _vm.item.action_by_reference.zip_code2
                                    }`
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("barcode")) +
                                      ": "
                                  ),
                                  _c(
                                    "b",
                                    { staticClass: "link-like" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          ai.interchange_by_reference.barcode
                                        ) + " "
                                      ),
                                      _c("svg-icon", {
                                        attrs: { "icon-class": "launch" }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-timeline",
                          { staticClass: "mt-5 pl-0 event-timeline" },
                          _vm._l(
                            ai.interchange_by_reference.interchange_events,
                            function(event) {
                              return _c(
                                "el-timeline-item",
                                {
                                  key: `${JSON.stringify(event)}`,
                                  attrs: {
                                    color: "#ed6b1c",
                                    timestamp: `${_vm.format(
                                      new Date(event.last_event_timestamp),
                                      "d/MM/yyyy - HH:mm"
                                    )}`
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleInterchangeEventClick(
                                        event
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "timelineitem interchange-event-clickable"
                                    },
                                    [
                                      _vm.item.message_code === "direct_debit"
                                        ? [
                                            _c("span", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.translateEventType(
                                                      ai
                                                        .interchange_by_reference
                                                        .channel,
                                                      event.event_type
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("p", { staticClass: "mt-0" }, [
                                              _vm._v(
                                                _vm._s(
                                                  event.channel_endpoint.message
                                                )
                                              )
                                            ])
                                          ]
                                        : [
                                            _c("span", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.translateEventType(
                                                      ai
                                                        .interchange_by_reference
                                                        .channel,
                                                      event.event_type
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          ]
                                    ],
                                    2
                                  )
                                ]
                              )
                            }
                          ),
                          1
                        )
                      ],
                      1
                    )
                  }
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      (_vm.item.metadata &&
        _vm.item.metadata.channels &&
        _vm.item.metadata.channels[0].reason) ||
      (_vm.item.metadata &&
        _vm.item.metadata.channels &&
        _vm.item.metadata.channels[0].callResult)
        ? _c(
            "el-collapse",
            [
              _c(
                "el-collapse-item",
                { attrs: { title: _vm.$t("moreInfo") } },
                [
                  _vm.item.metadata &&
                  _vm.item.metadata.channels &&
                  _vm.item.metadata.channels[0]
                    ? [
                        _vm.item.metadata &&
                        _vm.item.metadata.channels[0].reason
                          ? [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("reasonForCall")) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.item.metadata
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "rgb(115, 115, 115) !important"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.item.metadata.channels[0].reason
                                          ) +
                                          "\n\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.item.metadata &&
                        _vm.item.metadata.channels[0].callResult
                          ? [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("callResult")) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.item.metadata
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "rgb(115, 115, 115) !important"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.item.metadata.channels[0]
                                              .callResult
                                          ) +
                                          "\n\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item.action_invoices &&
                  _vm.item.action_invoices.length === 1
                    ? [
                        _c(
                          "div",
                          { staticClass: "mt-10" },
                          [
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("regardsTo")) +
                                    " " +
                                    _vm._s(_vm.$tc("invoice")) +
                                    " "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.item.action_by_reference
                              .primary_invoice_by_reference.invoice_number
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "cursor-pointer",
                                    attrs: { size: "mini" }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "hover-underline",
                                        attrs: {
                                          to: {
                                            name: "invoice-detail",
                                            params: {
                                              reference:
                                                _vm.item.action_by_reference
                                                  .primary_invoice_by_reference
                                                  .invoice_number
                                            }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.item.action_by_reference
                                                .primary_invoice_by_reference
                                                .invoice_number
                                            ) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("interchange-event-detail-dialog", {
        attrs: {
          visible: _vm.interchangeEventDialogVisible,
          "action-ref": _vm.interchangeDialogActionRef,
          "initial-event-ref": _vm.interchangeDialogInitialEventRef,
          item: _vm.item
        },
        on: {
          "update:visible": function($event) {
            _vm.interchangeEventDialogVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }